'use client';

import { Sun, Droplets, Leaf, Wind } from 'lucide-react';

/**
 * [DC01] Atomic component that returns the appropriate icon for different energy sources
 */
interface EnergySourceIconProps {
  type: 'solar' | 'water' | 'biomass' | 'biogas' | 'wind' | string;
  size?: number;
  className?: string;
}

// Named export for better tree-shaking and explicit imports
export function EnergySourceIcon({ 
  type, 
  size = 16, 
  className = '' 
}: EnergySourceIconProps) {
  // [CP01] Simple mapping function with early returns
  // [CP03] Use early returns for different icon types
  
  // Normalize the type to lowercase for comparison
  const normalizedType = type.toLowerCase();
  
  if (normalizedType === 'solar' || normalizedType === 'sonne') {
    return <Sun size={size} className={`text-yellow-500 ${className}`} />;
  }
  
  if (normalizedType === 'water' || normalizedType === 'wasser' || normalizedType === 'wasserkraft') {
    return <Droplets size={size} className={`text-blue-500 ${className}`} />;
  }
  
  if (normalizedType === 'biomass' || normalizedType === 'biomasse') {
    return <Leaf size={size} className={`text-green-600 ${className}`} />;
  }
  
  if (normalizedType === 'biogas') {
    return <Leaf size={size} className={`text-green-400 ${className}`} />;
  }
  
  if (normalizedType === 'wind') {
    return <Wind size={size} className={`text-sky-400 ${className}`} />;
  }
  
  // Default fallback icon
  return <Sun size={size} className={className} />;
}
